import { formatWholeDollars } from '../components/PlanPicker';
import { formatMoneyCents } from './format';
import {
  annualMonthlyEquivalentCents,
  annualPriceCents,
  annualSavingsCents,
  effectiveCycle,
  PLAN_LIST_PRICE_CENTS,
  planHasAnnualBilling,
  RESERVAS_FREE_BOOKINGS_PER_MONTH,
  RESERVAS_PER_BOOKING_CENTS,
  type BillingCycle,
  type PlanTier,
} from './plan';

/** "$50 al mes, pago mensual", "$480 al año, ahorras $120", or Independientes' per-booking line. */
export function chosenPlanPrice(plan: PlanTier, cycle: BillingCycle): string {
  if (!planHasAnnualBilling(plan)) {
    return `Sin mensualidad: ${RESERVAS_FREE_BOOKINGS_PER_MONTH} reservas gratis al mes, luego ${formatMoneyCents(RESERVAS_PER_BOOKING_CENTS)} cada una`;
  }
  const monthly = PLAN_LIST_PRICE_CENTS[plan];
  if (effectiveCycle(plan, cycle) === 'monthly') return `${formatWholeDollars(monthly)} al mes, pago mensual`;
  return `${formatWholeDollars(annualPriceCents(monthly))} al año, ahorras ${formatWholeDollars(annualSavingsCents(monthly))}`;
}

/**
 * The signup's price for a plan: on the year, the monthly amount for 12
 * months first and the year's total under it; on monthly, the plain price.
 */
export function planPriceLines(plan: PlanTier, cycle: BillingCycle): { price: string; total?: string } {
  if (!planHasAnnualBilling(plan)) return { price: chosenPlanPrice(plan, cycle) };
  const monthly = PLAN_LIST_PRICE_CENTS[plan];
  if (effectiveCycle(plan, cycle) === 'monthly') return { price: chosenPlanPrice(plan, cycle) };
  return {
    price: `${formatWholeDollars(annualMonthlyEquivalentCents(monthly))} al mes por 12 meses`,
    total: `Total ${formatWholeDollars(annualPriceCents(monthly))} al año`,
  };
}
